// modules
import React, { PureComponent } from 'react';
import { differenceInYears } from 'date-fns';

// aliased
import DocumentTitle from 'components/DocumentTitle';
import Icon from 'components/Icon';
import JobList from 'components/JobList';
import Link from 'components/Link';
import Section from 'components/Section';
import TagList from 'components/TagList';
import jobs from 'data/jobs';
import resume from 'static/Colby_Dauphinais_Resume.pdf';

// local
import ResumeHeader from './ResumeHeader';
import Education from './Education';
import styles from './ResumeView.pcss';

const SKILLS = [
  'JavaScript',
  'Node.js',
  'AWS',
  'FP',
  'GraphQL',
  'React',
  'TypeScript',
  'Haskell',
  'API',
  'REST',
  'Serverless',
  'Docker',
  'Scala',
  'DevOps',
  'CI / CD',
  '*nix',
  'UX / DX',
  'SQL',
  'Git',
  'Agile',
  'HTML / CSS',
  // cloud?
];

const yearsCoding = differenceInYears(new Date(), '2001-09-17');

const EDUCATION = [
  {
    course: 'Web & Software Development',
    almaMater: `${ yearsCoding }-year self-educated enthusiast`,
  },
  {
    course: 'International Management',
    almaMater: 'Pace University',
  },
];

export default class ResumeView extends PureComponent {
  
  static propTypes = {}
  static defaultProps = {}
  
  get download() {
    return (
      <Link
        to={ resume }
        className={ styles.download }
        title={ 'download resume' }
        download={ 'Colby_Dauphinais_Resume' }
        onClick={ this.handleResumeDownload }
        openNew={ true }
      >
        <Icon type={ 'file_download' } />
      </Link>
    );
  }
  
  handleResumeDownload = () => {
    // publish resume download event to google analytics
    // eslint-disable-next-line no-unused-expressions
    window.ga && window.ga('send', 'event', 'resume', 'download');
  }
  
  render() {
    return (
      <div className={ styles.resumeView }>
        <DocumentTitle title={ 'Colby Dauphinais - Resume' } />
        { this.download }
        <div className={ styles.paper }>
          <ResumeHeader className={ styles.resumeHeader } />
          <div className={ styles.content }>
            <Section className={ styles.experience } title={ 'Experience' }>
              <JobList jobs={ jobs } />
            </Section>
            <div className={ styles.rightCol }>
              <Section className={ styles.skills } title={ 'Skills & Interests' }>
                <TagList tagClassName={ styles.tag } tags={ SKILLS } />
              </Section>
              <Section className={ styles.education } title={ 'Education' }>
                <Education items={ EDUCATION } />
              </Section>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/views/ResumeView/index.jsx